// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Corporate Palette */
  --bq-primary-dark: #0f172a;    /* Slate 900 */
  --bq-primary: #2563eb;         /* Blue 600 */
  --bq-primary-hover: #1d4ed8;   /* Blue 700 */
  --bq-success: #10b981;         /* Emerald 500 */
  --bq-bg-light: #f8fafc;        /* Slate 50 */
  --bq-border-color: #e2e8f0;    /* Slate 200 */
  --bq-text-muted: #64748b;      /* Slate 500 */
  
  /* Bootstrap Overrides */
  --bs-body-bg: #f8fafc;
  --bs-primary: #2563eb;
  --bs-primary-rgb: 37, 99, 235;
  --bs-link-decoration: none;
}

[data-bs-theme="dark"] {
  --bq-primary-dark: #020617;    /* Slate 950 */
  --bq-primary: #3b82f6;         /* Blue 500 */
  --bq-primary-hover: #60a5fa;   /* Blue 400 */
  --bq-bg-light: #0f172a;        /* Slate 900 */
  --bq-border-color: #1e293b;    /* Slate 800 */
  --bq-text-muted: #94a3b8;      /* Slate 400 */
  
  --bs-body-bg: #0f172a;
  --bs-body-color: #f1f5f9;
  --bs-border-color: #1e293b;
}

html, body {
  height: 100%;
  overflow: hidden; /* Prevent global scroll */
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
}

.seo-hero {
  position: fixed;
  inset: 72px 0 0 0;
  z-index: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
  padding: 48px 24px;
  color: var(--bs-body-color);
}

.seo-hero-content {
  max-width: 900px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 24px;
  padding: 32px;
  background: transparent;
}

.seo-hero-icon {
  width: 72px;
  height: 72px;
  font-size: 1.75rem;
}

.seo-hero-content h1 {
  font-size: 2.25rem;
  letter-spacing: -0.02em;
}

.seo-hero-content .badge {
  border-color: rgba(148, 163, 184, 0.35) !important;
}

[data-bs-theme="dark"] .seo-hero-content {
  border-color: rgba(148, 163, 184, 0.15);
}

[data-bs-theme="dark"] .seo-hero-content .badge {
  border-color: rgba(148, 163, 184, 0.25) !important;
}

/* Layout Containers */
.app-layout {
  flex: 1;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
}

.row {
  height: 100%;
  margin: 0;
}

/* Utilities */
.tracking-tight { letter-spacing: -0.025em; }
.tracking-wide { letter-spacing: 0.025em; }
.tracking-wider { letter-spacing: 0.05em; }

.shadow-up {
  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.05), 0 -2px 4px -1px rgba(0, 0, 0, 0.03);
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.5);
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.8);
}

/* Navbar */
#mainNavbar {
  flex-shrink: 0;
  background-color: var(--bq-primary-dark);
  border-bottom: 1px solid rgba(255,255,255,0.1) !important;
  z-index: 2;
}

#mainNavbar .container-fluid {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.brand-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--bq-primary), #60a5fa);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.hover-white:hover {
  color: white !important;
  transition: color 0.2s;
}

/* Sidebar */
.sidebar-container {
  height: 100%;
  background-color: var(--bs-body-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Inner content handles scroll */
}

/* Ensure lists inside sidebar scroll independently */
.project-list, .chat-list {
  overflow-y: auto;
  scrollbar-width: thin;
}

.list-group-item-action {
  border: none;
  border-radius: 6px;
  margin-bottom: 2px;
  color: var(--bq-text-muted);
  font-weight: 500;
  padding: 0.6rem 1rem;
}

.list-group-item-action:hover {
  background-color: rgba(37, 99, 235, 0.05);
  color: var(--bq-primary);
}

.list-group-item-action.active {
  background-color: rgba(37, 99, 235, 0.1);
  color: var(--bq-primary);
  border-left: 3px solid var(--bq-primary);
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.btn-icon-primary {
  color: var(--bq-primary);
  background: rgba(37, 99, 235, 0.1);
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.btn-icon-primary:hover {
  background: var(--bq-primary);
  color: white;
}

.avatar-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
}

/* Main Panel */
main {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Main Card & Tabs */
.interaction-card {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025);
  border: 1px solid var(--bq-border-color) !important;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

/* Review Mode Expansion */
.interaction-card.expanded-mode {
  height: 50vh;
}

.bottom-panel-container {
    transition: all 0.3s ease;
}

.nav-tabs-custom {
  border-bottom: none;
}

.nav-tabs-custom .nav-link {
  border: none;
  color: var(--bq-text-muted);
  font-weight: 500;
  font-size: 0.9rem;
  padding: 0.75rem 1rem;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;
  background: transparent !important;
}

.nav-tabs-custom .nav-link:hover:not(.disabled) {
  color: var(--bq-primary);
  border-bottom-color: rgba(37, 99, 235, 0.3);
}

.nav-tabs-custom .nav-link.active {
  color: var(--bq-primary);
  border-bottom-color: var(--bq-primary);
  background: transparent !important;
}

.nav-tabs-custom .nav-link.disabled {
  color: rgba(148, 163, 184, 0.5);
}

/* Drop Zone & Inputs */
.file-drop-zone {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  border: 2px dashed var(--bq-border-color);
  background-color: rgba(248, 250, 252, 0.95);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  pointer-events: none;
  backdrop-filter: blur(2px);
}

.file-drop-zone.drag-over {
  opacity: 1;
  visibility: visible;
  background-color: rgba(37, 99, 235, 0.05);
  border-color: var(--bq-primary);
  backdrop-filter: blur(4px);
}

[data-bs-theme="dark"] .file-drop-zone {
  background-color: rgba(15, 23, 42, 0.95);
}

.custom-textarea {
  font-size: 1rem;
  line-height: 1.5;
  color: var(--bs-body-color);
  min-height: 56px;
  max-height: 200px;
  resize: none;
  overflow-y: hidden;
}
.custom-textarea:focus {
  box-shadow: none;
  background-color: transparent;
}
.custom-textarea::placeholder {
  color: var(--bq-text-muted);
  opacity: 0.6;
}

/* Toolbar Buttons */
.btn-icon-secondary {
    color: var(--bq-text-muted);
    transition: all 0.2s;
}
.btn-icon-secondary:hover {
    background-color: var(--bq-bg-light);
    color: var(--bs-body-color);
}
[data-bs-theme="dark"] .btn-icon-secondary:hover {
    background-color: rgba(255,255,255,0.1);
}

/* Buttons */
.btn-gradient-primary {
  background: linear-gradient(135deg, var(--bq-primary), #1d4ed8);
  border: none;
  transition: transform 0.1s, box-shadow 0.2s;
}
.btn-gradient-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.3);
  background: linear-gradient(135deg, #1d4ed8, #1e40af);
}
.btn-gradient-primary:active {
  transform: translateY(0);
}
.btn-gradient-primary:disabled {
  background: #e2e8f0;
  box-shadow: none;
  transform: none;
  color: #94a3b8;
}
[data-bs-theme="dark"] .btn-gradient-primary:disabled {
  background: #334155;
  color: #64748b;
}

.btn-white-alpha {
  background-color: rgba(255,255,255,0.2);
  backdrop-filter: blur(4px);
}
.btn-white-alpha:hover {
  background-color: rgba(255,255,255,0.3);
  color: white;
}

/* Chat Bubbles */
.message-bubble {
  max-width: 80%;
  padding: 1rem 1.25rem;
  border-radius: 1rem;
  font-size: 0.95rem;
  line-height: 1.6;
  position: relative;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.message-user {
  background-color: var(--bq-primary);
  color: white;
  border-bottom-right-radius: 0.25rem;
  margin-left: auto;
}

.message-user a {
  color: #e0f2fe;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.message-user a:hover {
  color: #ffffff;
}

.message-user a:visited {
  color: #dbeafe;
}

.message-ai {
  background-color: white;
  border: 1px solid var(--bq-border-color);
  border-bottom-left-radius: 0.25rem;
  color: var(--bs-body-color);
}

[data-bs-theme="dark"] .message-ai {
  background-color: #1e293b;
  border-color: #334155;
}

.message-user .card {
  background: transparent;
  color: inherit;
}

.message-user .card-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.message-user .nav-tabs {
  border-bottom: none;
  gap: 0.35rem;
}

.message-user .nav-tabs .nav-link {
  color: rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0.6rem 0.6rem 0 0;
  transition: color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.message-user .nav-tabs .nav-link:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.2);
}

.message-user .nav-tabs .nav-link.active {
  color: #0f172a;
  background: rgba(248, 250, 252, 0.92);
  border-color: rgba(255, 255, 255, 0.55);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.16);
}

.message-user .nav-tabs .nav-link:focus-visible {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);
}

.message-user .tab-pane {
  color: #f8fafc;
}

.message-user .btn-link {
  color: rgba(255, 255, 255, 0.82);
}

.message-user .btn-link:hover {
  color: #ffffff;
}

.message-user .btn-link svg {
  filter: drop-shadow(0 1px 2px rgba(15, 23, 42, 0.35));
}

/* Diff Highlighting */
.diff-content del {
  background-color: rgba(239, 68, 68, 0.2);
  color: #b91c1c;
  text-decoration: none;
  border-radius: 2px;
  padding: 0 2px;
}

.diff-content ins {
  background-color: rgba(16, 185, 129, 0.2);
  color: #047857;
  text-decoration: none;
  border-radius: 2px;
  padding: 0 2px;
}

[data-bs-theme="dark"] .diff-content del {
  background-color: rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

[data-bs-theme="dark"] .diff-content ins {
  background-color: rgba(16, 185, 129, 0.3);
  color: #6ee7b7;
}

/* Entity Tags */
.entity-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 12px;
  background-color: rgba(37, 99, 235, 0.1);
  color: var(--bq-primary);
  border: 1px solid rgba(37, 99, 235, 0.2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 2px;
  vertical-align: middle;
}

/* File Attachments */
.attached-files {
  border-radius: 0.5rem;
}

/* Dropdown Menu Styles */
.dropdown-menu {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border-radius: 0.75rem;
  transition: opacity 0.2s, transform 0.2s;
}

.dropdown-menu.show {
  display: block;
  z-index: 2000;
  position: absolute;
  bottom: 100%;
  margin-bottom: 0.5rem;
}

/* Processing Animations */
@keyframes pulse-ring {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
  }
}

.btn-processing {
  animation: pulse-ring 1.5s infinite;
  background-color: var(--bq-primary) !important;
  border-color: var(--bq-primary) !important;
}

@keyframes pulse-shield {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.15); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}

.icon-processing {
  animation: pulse-shield 1.5s infinite ease-in-out;
  color: white;
}

/* User Interface Utilities */
.cursor-pointer {
  cursor: pointer;
}

.hover-bg-light:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s;
}

[data-bs-theme="dark"] .hover-bg-light:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.social-login-btn {
  transition: all 0.2s;
  border-width: 1.5px;
}

.social-login-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.social-login-btn:active {
  transform: translateY(0);
}

#upgradeBtn {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(37, 99, 235, 0.05));
  transition: all 0.2s;
}

#upgradeBtn:hover {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.2), rgba(37, 99, 235, 0.1));
}

.byok-key-item {
  border: 1px solid var(--bq-border-color);
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bs-body-bg);
}

.byok-key-preview {
  font-family: 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', monospace;
  letter-spacing: 0.04em;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.byok-models {
  font-size: 0.75rem;
  color: var(--bq-text-muted);
}

/* Settings Modal */
.settings-modal .nav-tabs {
  border-bottom: 1px solid var(--bq-border-color);
}

.settings-modal .nav-tabs .nav-link {
  border: none;
  color: var(--bq-text-muted);
  font-weight: 600;
  padding: 0.6rem 1rem;
}

.settings-modal .nav-tabs .nav-link.active {
  color: var(--bq-primary);
  border-bottom: 2px solid var(--bq-primary);
  background: transparent;
}

.settings-section {
  padding: 1.25rem;
  border: 1px solid var(--bq-border-color);
  border-radius: 1rem;
  background: var(--bs-body-bg);
  box-shadow: 0 10px 18px -12px rgba(15, 23, 42, 0.2);
  margin-bottom: 1.5rem;
}

.settings-textarea {
  resize: vertical;
  font-size: 0.9rem;
}

.settings-card {
  border: 1px solid var(--bq-border-color);
  border-radius: 0.9rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.65);
  height: 100%;
}

[data-bs-theme="dark"] .settings-card {
  background: rgba(15, 23, 42, 0.4);
}

.settings-card .form-check-input {
  cursor: pointer;
}

.settings-card .form-check-input:checked {
  background-color: var(--bq-primary);
  border-color: var(--bq-primary);
}

.settings-card .form-check-input:focus {
  box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/frontend/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,0BAA0B,KAAK,cAAc;EAC7C,qBAAqB,UAAU,aAAa;EAC5C,2BAA2B,IAAI,aAAa;EAC5C,qBAAqB,UAAU,gBAAgB;EAC/C,sBAAsB,SAAS,aAAa;EAC5C,0BAA0B,KAAK,cAAc;EAC7C,wBAAwB,OAAO,cAAc;;EAE7C,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B,KAAK,cAAc;EAC7C,qBAAqB,UAAU,aAAa;EAC5C,2BAA2B,IAAI,aAAa;EAC5C,sBAAsB,SAAS,cAAc;EAC7C,0BAA0B,KAAK,cAAc;EAC7C,wBAAwB,OAAO,cAAc;;EAE7C,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,gHAAgH;EAChH,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA,cAAc;AACd,kBAAkB,wBAAwB,EAAE;AAC5C,iBAAiB,uBAAuB,EAAE;AAC1C,kBAAkB,sBAAsB,EAAE;;AAE1C;EACE,oFAAoF;AACtF;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,cAAc;EACd,wCAAwC;EACxC,yDAAyD;EACzD,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+DAA+D;EAC/D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,qFAAqF;EACrF,mDAAmD;EACnD,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,2CAA2C;EAC3C,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;AACA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;AACA;IACI,uCAAuC;AAC3C;;AAEA,YAAY;AACZ;EACE,+DAA+D;EAC/D,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,qDAAqD;AACvD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,qGAAqG;AACvG;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;EACxC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,wBAAwB;EACxB,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,KAAK,mBAAmB,EAAE,UAAU,EAAE;EACtC,MAAM,sBAAsB,EAAE,YAAY,EAAE;EAC5C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,iDAAiD;EACjD,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oFAAoF;EACpF,oBAAoB;AACtB;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yGAAyG;EACzG,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,6BAA6B;EAC7B,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":[":root {\n  /* Corporate Palette */\n  --bq-primary-dark: #0f172a;    /* Slate 900 */\n  --bq-primary: #2563eb;         /* Blue 600 */\n  --bq-primary-hover: #1d4ed8;   /* Blue 700 */\n  --bq-success: #10b981;         /* Emerald 500 */\n  --bq-bg-light: #f8fafc;        /* Slate 50 */\n  --bq-border-color: #e2e8f0;    /* Slate 200 */\n  --bq-text-muted: #64748b;      /* Slate 500 */\n  \n  /* Bootstrap Overrides */\n  --bs-body-bg: #f8fafc;\n  --bs-primary: #2563eb;\n  --bs-primary-rgb: 37, 99, 235;\n  --bs-link-decoration: none;\n}\n\n[data-bs-theme=\"dark\"] {\n  --bq-primary-dark: #020617;    /* Slate 950 */\n  --bq-primary: #3b82f6;         /* Blue 500 */\n  --bq-primary-hover: #60a5fa;   /* Blue 400 */\n  --bq-bg-light: #0f172a;        /* Slate 900 */\n  --bq-border-color: #1e293b;    /* Slate 800 */\n  --bq-text-muted: #94a3b8;      /* Slate 400 */\n  \n  --bs-body-bg: #0f172a;\n  --bs-body-color: #f1f5f9;\n  --bs-border-color: #1e293b;\n}\n\nhtml, body {\n  height: 100%;\n  overflow: hidden; /* Prevent global scroll */\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: flex;\n  flex-direction: column;\n}\n\n.seo-hero {\n  position: fixed;\n  inset: 72px 0 0 0;\n  z-index: 0;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  padding: 48px 24px;\n  color: var(--bs-body-color);\n}\n\n.seo-hero-content {\n  max-width: 900px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 24px;\n  padding: 32px;\n  background: transparent;\n}\n\n.seo-hero-icon {\n  width: 72px;\n  height: 72px;\n  font-size: 1.75rem;\n}\n\n.seo-hero-content h1 {\n  font-size: 2.25rem;\n  letter-spacing: -0.02em;\n}\n\n.seo-hero-content .badge {\n  border-color: rgba(148, 163, 184, 0.35) !important;\n}\n\n[data-bs-theme=\"dark\"] .seo-hero-content {\n  border-color: rgba(148, 163, 184, 0.15);\n}\n\n[data-bs-theme=\"dark\"] .seo-hero-content .badge {\n  border-color: rgba(148, 163, 184, 0.25) !important;\n}\n\n/* Layout Containers */\n.app-layout {\n  flex: 1;\n  overflow: hidden;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 1;\n}\n\n.row {\n  height: 100%;\n  margin: 0;\n}\n\n/* Utilities */\n.tracking-tight { letter-spacing: -0.025em; }\n.tracking-wide { letter-spacing: 0.025em; }\n.tracking-wider { letter-spacing: 0.05em; }\n\n.shadow-up {\n  box-shadow: 0 -4px 6px -1px rgba(0, 0, 0, 0.05), 0 -2px 4px -1px rgba(0, 0, 0, 0.03);\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.5);\n  border-radius: 10px;\n}\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: rgba(148, 163, 184, 0.8);\n}\n\n/* Navbar */\n#mainNavbar {\n  flex-shrink: 0;\n  background-color: var(--bq-primary-dark);\n  border-bottom: 1px solid rgba(255,255,255,0.1) !important;\n  z-index: 2;\n}\n\n#mainNavbar .container-fluid {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.brand-icon {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, var(--bq-primary), #60a5fa);\n  color: white;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.hover-white:hover {\n  color: white !important;\n  transition: color 0.2s;\n}\n\n/* Sidebar */\n.sidebar-container {\n  height: 100%;\n  background-color: var(--bs-body-bg);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* Inner content handles scroll */\n}\n\n/* Ensure lists inside sidebar scroll independently */\n.project-list, .chat-list {\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.list-group-item-action {\n  border: none;\n  border-radius: 6px;\n  margin-bottom: 2px;\n  color: var(--bq-text-muted);\n  font-weight: 500;\n  padding: 0.6rem 1rem;\n}\n\n.list-group-item-action:hover {\n  background-color: rgba(37, 99, 235, 0.05);\n  color: var(--bq-primary);\n}\n\n.list-group-item-action.active {\n  background-color: rgba(37, 99, 235, 0.1);\n  color: var(--bq-primary);\n  border-left: 3px solid var(--bq-primary);\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.btn-icon-primary {\n  color: var(--bq-primary);\n  background: rgba(37, 99, 235, 0.1);\n  border: none;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.btn-icon-primary:hover {\n  background: var(--bq-primary);\n  color: white;\n}\n\n.avatar-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n/* Main Panel */\nmain {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Main Card & Tabs */\n.interaction-card {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.025);\n  border: 1px solid var(--bq-border-color) !important;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Review Mode Expansion */\n.interaction-card.expanded-mode {\n  height: 50vh;\n}\n\n.bottom-panel-container {\n    transition: all 0.3s ease;\n}\n\n.nav-tabs-custom {\n  border-bottom: none;\n}\n\n.nav-tabs-custom .nav-link {\n  border: none;\n  color: var(--bq-text-muted);\n  font-weight: 500;\n  font-size: 0.9rem;\n  padding: 0.75rem 1rem;\n  transition: all 0.2s;\n  border-bottom: 2px solid transparent;\n  background: transparent !important;\n}\n\n.nav-tabs-custom .nav-link:hover:not(.disabled) {\n  color: var(--bq-primary);\n  border-bottom-color: rgba(37, 99, 235, 0.3);\n}\n\n.nav-tabs-custom .nav-link.active {\n  color: var(--bq-primary);\n  border-bottom-color: var(--bq-primary);\n  background: transparent !important;\n}\n\n.nav-tabs-custom .nav-link.disabled {\n  color: rgba(148, 163, 184, 0.5);\n}\n\n/* Drop Zone & Inputs */\n.file-drop-zone {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 5;\n  border: 2px dashed var(--bq-border-color);\n  background-color: rgba(248, 250, 252, 0.95);\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  pointer-events: none;\n  backdrop-filter: blur(2px);\n}\n\n.file-drop-zone.drag-over {\n  opacity: 1;\n  visibility: visible;\n  background-color: rgba(37, 99, 235, 0.05);\n  border-color: var(--bq-primary);\n  backdrop-filter: blur(4px);\n}\n\n[data-bs-theme=\"dark\"] .file-drop-zone {\n  background-color: rgba(15, 23, 42, 0.95);\n}\n\n.custom-textarea {\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  min-height: 56px;\n  max-height: 200px;\n  resize: none;\n  overflow-y: hidden;\n}\n.custom-textarea:focus {\n  box-shadow: none;\n  background-color: transparent;\n}\n.custom-textarea::placeholder {\n  color: var(--bq-text-muted);\n  opacity: 0.6;\n}\n\n/* Toolbar Buttons */\n.btn-icon-secondary {\n    color: var(--bq-text-muted);\n    transition: all 0.2s;\n}\n.btn-icon-secondary:hover {\n    background-color: var(--bq-bg-light);\n    color: var(--bs-body-color);\n}\n[data-bs-theme=\"dark\"] .btn-icon-secondary:hover {\n    background-color: rgba(255,255,255,0.1);\n}\n\n/* Buttons */\n.btn-gradient-primary {\n  background: linear-gradient(135deg, var(--bq-primary), #1d4ed8);\n  border: none;\n  transition: transform 0.1s, box-shadow 0.2s;\n}\n.btn-gradient-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.3);\n  background: linear-gradient(135deg, #1d4ed8, #1e40af);\n}\n.btn-gradient-primary:active {\n  transform: translateY(0);\n}\n.btn-gradient-primary:disabled {\n  background: #e2e8f0;\n  box-shadow: none;\n  transform: none;\n  color: #94a3b8;\n}\n[data-bs-theme=\"dark\"] .btn-gradient-primary:disabled {\n  background: #334155;\n  color: #64748b;\n}\n\n.btn-white-alpha {\n  background-color: rgba(255,255,255,0.2);\n  backdrop-filter: blur(4px);\n}\n.btn-white-alpha:hover {\n  background-color: rgba(255,255,255,0.3);\n  color: white;\n}\n\n/* Chat Bubbles */\n.message-bubble {\n  max-width: 80%;\n  padding: 1rem 1.25rem;\n  border-radius: 1rem;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  position: relative;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n\n.message-user {\n  background-color: var(--bq-primary);\n  color: white;\n  border-bottom-right-radius: 0.25rem;\n  margin-left: auto;\n}\n\n.message-user a {\n  color: #e0f2fe;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.message-user a:hover {\n  color: #ffffff;\n}\n\n.message-user a:visited {\n  color: #dbeafe;\n}\n\n.message-ai {\n  background-color: white;\n  border: 1px solid var(--bq-border-color);\n  border-bottom-left-radius: 0.25rem;\n  color: var(--bs-body-color);\n}\n\n[data-bs-theme=\"dark\"] .message-ai {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.message-user .card {\n  background: transparent;\n  color: inherit;\n}\n\n.message-user .card-header {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.message-user .nav-tabs {\n  border-bottom: none;\n  gap: 0.35rem;\n}\n\n.message-user .nav-tabs .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 0.6rem 0.6rem 0 0;\n  transition: color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.message-user .nav-tabs .nav-link:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.message-user .nav-tabs .nav-link.active {\n  color: #0f172a;\n  background: rgba(248, 250, 252, 0.92);\n  border-color: rgba(255, 255, 255, 0.55);\n  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.16);\n}\n\n.message-user .nav-tabs .nav-link:focus-visible {\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.35);\n}\n\n.message-user .tab-pane {\n  color: #f8fafc;\n}\n\n.message-user .btn-link {\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.message-user .btn-link:hover {\n  color: #ffffff;\n}\n\n.message-user .btn-link svg {\n  filter: drop-shadow(0 1px 2px rgba(15, 23, 42, 0.35));\n}\n\n/* Diff Highlighting */\n.diff-content del {\n  background-color: rgba(239, 68, 68, 0.2);\n  color: #b91c1c;\n  text-decoration: none;\n  border-radius: 2px;\n  padding: 0 2px;\n}\n\n.diff-content ins {\n  background-color: rgba(16, 185, 129, 0.2);\n  color: #047857;\n  text-decoration: none;\n  border-radius: 2px;\n  padding: 0 2px;\n}\n\n[data-bs-theme=\"dark\"] .diff-content del {\n  background-color: rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n\n[data-bs-theme=\"dark\"] .diff-content ins {\n  background-color: rgba(16, 185, 129, 0.3);\n  color: #6ee7b7;\n}\n\n/* Entity Tags */\n.entity-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  border-radius: 12px;\n  background-color: rgba(37, 99, 235, 0.1);\n  color: var(--bq-primary);\n  border: 1px solid rgba(37, 99, 235, 0.2);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 2px;\n  vertical-align: middle;\n}\n\n/* File Attachments */\n.attached-files {\n  border-radius: 0.5rem;\n}\n\n/* Dropdown Menu Styles */\n.dropdown-menu {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border-radius: 0.75rem;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.dropdown-menu.show {\n  display: block;\n  z-index: 2000;\n  position: absolute;\n  bottom: 100%;\n  margin-bottom: 0.5rem;\n}\n\n/* Processing Animations */\n@keyframes pulse-ring {\n  0% {\n    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);\n  }\n}\n\n.btn-processing {\n  animation: pulse-ring 1.5s infinite;\n  background-color: var(--bq-primary) !important;\n  border-color: var(--bq-primary) !important;\n}\n\n@keyframes pulse-shield {\n  0% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.15); opacity: 0.8; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n.icon-processing {\n  animation: pulse-shield 1.5s infinite ease-in-out;\n  color: white;\n}\n\n/* User Interface Utilities */\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.hover-bg-light:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  transition: background-color 0.2s;\n}\n\n[data-bs-theme=\"dark\"] .hover-bg-light:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.social-login-btn {\n  transition: all 0.2s;\n  border-width: 1.5px;\n}\n\n.social-login-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.social-login-btn:active {\n  transform: translateY(0);\n}\n\n#upgradeBtn {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.1), rgba(37, 99, 235, 0.05));\n  transition: all 0.2s;\n}\n\n#upgradeBtn:hover {\n  background: linear-gradient(135deg, rgba(37, 99, 235, 0.2), rgba(37, 99, 235, 0.1));\n}\n\n.byok-key-item {\n  border: 1px solid var(--bq-border-color);\n  border-radius: 0.75rem;\n  padding: 0.75rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--bs-body-bg);\n}\n\n.byok-key-preview {\n  font-family: 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', monospace;\n  letter-spacing: 0.04em;\n  max-width: 260px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.byok-models {\n  font-size: 0.75rem;\n  color: var(--bq-text-muted);\n}\n\n/* Settings Modal */\n.settings-modal .nav-tabs {\n  border-bottom: 1px solid var(--bq-border-color);\n}\n\n.settings-modal .nav-tabs .nav-link {\n  border: none;\n  color: var(--bq-text-muted);\n  font-weight: 600;\n  padding: 0.6rem 1rem;\n}\n\n.settings-modal .nav-tabs .nav-link.active {\n  color: var(--bq-primary);\n  border-bottom: 2px solid var(--bq-primary);\n  background: transparent;\n}\n\n.settings-section {\n  padding: 1.25rem;\n  border: 1px solid var(--bq-border-color);\n  border-radius: 1rem;\n  background: var(--bs-body-bg);\n  box-shadow: 0 10px 18px -12px rgba(15, 23, 42, 0.2);\n  margin-bottom: 1.5rem;\n}\n\n.settings-textarea {\n  resize: vertical;\n  font-size: 0.9rem;\n}\n\n.settings-card {\n  border: 1px solid var(--bq-border-color);\n  border-radius: 0.9rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.65);\n  height: 100%;\n}\n\n[data-bs-theme=\"dark\"] .settings-card {\n  background: rgba(15, 23, 42, 0.4);\n}\n\n.settings-card .form-check-input {\n  cursor: pointer;\n}\n\n.settings-card .form-check-input:checked {\n  background-color: var(--bq-primary);\n  border-color: var(--bq-primary);\n}\n\n.settings-card .form-check-input:focus {\n  box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
